import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Puff } from 'react-loader-spinner'
import { BiTrash, BiPlusMedical } from 'react-icons/bi'

import styles from './styles.module.scss'
import Li from '../../components/Li'
import Button from '../../components/Button'
import Confirmation from '../../components/Confirmation/Confirmation'
import TypesOfDiseaseModal from './Modal'
import { deleteTypesOfDisease, getTypesOfDisease } from '../../actions/medCenter/typesOfDisease'

export default function TypesOfDisease() {
  const dispatch = useDispatch()
  const { diseaseList, loading } = useSelector(state => state.directoryMedCenter)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(null)
  const [isDeleting, setIsDeleting] = useState(false)

  useEffect(() => {
    dispatch(getTypesOfDisease())
  }, [dispatch])

  const handleDelete = useCallback((id) => (e) => {
    e.stopPropagation()
    setConfirmation(id)
  }, [])

  const openModal = useCallback((data) => () => {
    setSelectedItem(data || {})
  }, [])

  const closeModal = useCallback(() => {
    setSelectedItem(null)
  }, [])

  const acceptConfirmation = useCallback(async () => {
    setIsDeleting(true)
    try {
      await dispatch(deleteTypesOfDisease(confirmation))
    } finally {
      setConfirmation(null)
      setIsDeleting(false)
    }
  }, [dispatch, confirmation])

  const rejectConfirmation = useCallback(() => {
    setConfirmation(null)
  }, [])

  const sortedList = useMemo(() => {
    if (!diseaseList) return []
    return [...diseaseList].sort((a, b) => a.name?.localeCompare(b.name))
  }, [diseaseList])

  const renderEmptyState = () => (
    <div className={styles.emptyState}>
      <BiPlusMedical size={64} className={styles.emptyIcon} />
      <p>Нет добавленных видов болезни</p>
      <Button onClick={openModal()}>Добавить первый вид болезни</Button>
    </div>
  )

  const renderLoading = () => (
    <div className={styles.loadingState}>
      <Puff
        height={50}
        width={50}
        color="#3689FF"
        ariaLabel="Загрузка..."
      />
      <span>Загрузка видов болезни...</span>
    </div>
  )

  const renderList = () => (
    <div className={styles.listContainer}>
      <ul className={styles.list}>
        {sortedList.map((item) => (
          <Li
            key={item.disease}
            onClick={openModal(item)}
            className={styles.listItem}
          >
            <div className={styles.itemContent}>
              <BiPlusMedical size={20} className={styles.itemIcon} />
              <span className={styles.itemName}>{item.name}</span>
            </div>
            <button
              type="button"
              className={styles.deleteBtn}
              onClick={handleDelete(item.disease)}
              title="Удалить вид болезни"
              aria-label={`Удалить ${item.name}`}
            >
              <BiTrash size={22} />
            </button>
          </Li>
        ))}
      </ul>
      <div className={styles.actions}>
        <Button onClick={openModal()}>Добавить вид болезни</Button>
        <span className={styles.counter}>
          Всего: {sortedList.length}
        </span>
      </div>
    </div>
  )

  const isModalOpen = selectedItem !== null
  const isAddMode = selectedItem && !selectedItem.disease

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <h1>Виды болезни</h1>
      </header>

      <main className={styles.content}>
        {loading && renderLoading()}
        {!loading && sortedList.length === 0 && renderEmptyState()}
        {!loading && sortedList.length > 0 && renderList()}
      </main>

      <TypesOfDiseaseModal
        open={isModalOpen}
        onClose={closeModal}
        data={selectedItem}
        addMode={isAddMode}
      />

      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title="Уверены что хотите удалить вид болезни?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
          loading={isDeleting}
        />
      )}
    </div>
  )
}
